/* Decorative section videos were costing ~6MB on first paint: two sections use
   the SAME 3MB clip and both carried `autoplay`, so the browser downloaded it
   twice before the visitor had scrolled anywhere.

   Autoplay is removed in the markup; playback now starts when the element is
   near the viewport. The poster still paints immediately, so nothing is hidden
   behind the reveal — only the download is deferred. */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[data-defer]'));
  if (!vids.length) return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  function start(v) {
    if (v.dataset.on === '1') return;
    v.dataset.on = '1';
    v.preload = 'auto';
    // <source> children need a load() before they will fetch
    if (!v.src && v.querySelector('source')) v.load();
    if (reduce) return;              // poster only, no playback
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) start(e.target);
      else if (e.target.dataset.on === '1' && !e.target.paused) e.target.pause();
    });
  /* ⛔ 900px of look-ahead is a whole extra screen on a phone: the EX13 clip sat
     inside it on a 412px-wide page and downloaded during first load, competing
     with the render-blocking CSS and the LCP image for a slow connection. The
     poster paints either way; only when the download starts changes. */
  }, { rootMargin: (innerWidth < 900 ? '300px' : '900px') + ' 0px' });

  vids.forEach(function (v) { io.observe(v); });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) vids.forEach(function (v) { if (!v.paused) v.pause(); });
  });
})();
